"use strict";

exports.__esModule = true;
exports.render = render;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = _interopRequireDefault(require("@bbob/core"));

var html = _interopRequireWildcard(require("@bbob/html"));

var _pluginHelper = require("@bbob/plugin-helper");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var toAST = (source, plugins, options) => (0, _core.default)(plugins).process(source, _extends({}, options, {
  render: input => html.render(input, {
    stripTags: true
  })
})).tree;

var isContentEmpty = content => !content || content.length === 0;

function tagToReactElement(node, index) {
  return _react.default.createElement(node.tag, _extends({}, node.attrs, {
    key: index
  }), isContentEmpty(node.content) ? null : renderToReactNodes(node.content));
}

function renderToReactNodes(nodes) {
  var els = [].concat(nodes).reduce((arr, node, index) => {
    if ((0, _pluginHelper.isTagNode)(node)) {
      arr.push(tagToReactElement(node, index));
    } else if ((0, _pluginHelper.isStringNode)(node)) {
      arr.push(node);
    }

    return arr;
  }, []);
  return els;
}

function render(source, plugins, options) {
  return renderToReactNodes(toAST(source, plugins, options));
}

var _default = render;
exports.default = _default;